var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "drop-shadow afterSave root",
      attrs: { "max-width": "500" },
    },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("report-finished")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        { staticClass: "hide-overflow" },
        [
          _c("w-row", { attrs: { "no-margin": "" } }, [
            _c("div", { staticClass: "ready" }, [
              _vm._v(_vm._s(_vm.$ct("ready"))),
            ]),
          ]),
          _c("w-row", { attrs: { "no-margin": "" } }, [
            _c(
              "div",
              { staticClass: "button-box mt" },
              [
                _vm.canPrint
                  ? _c(
                      "w-button",
                      {
                        staticClass: "download",
                        attrs: { disabled: _vm.isPrinting },
                        on: {
                          click: function ($event) {
                            return _vm.print()
                          },
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "print" } }),
                        _c("w-spacer"),
                        _vm._v(" " + _vm._s(_vm.$ct("print")) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canPrint
                  ? _c(
                      "w-button",
                      {
                        staticClass: "download ml",
                        attrs: { disabled: _vm.isPreparingPreview },
                        on: {
                          click: function ($event) {
                            return _vm.preview()
                          },
                        },
                      },
                      [
                        _c("w-fa", { attrs: { icon: "eye" } }),
                        _c("w-spacer"),
                        _vm._v(" " + _vm._s(_vm.$ct("preview")) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-button",
                  {
                    staticClass: "download ml",
                    on: {
                      click: function ($event) {
                        return _vm.download()
                      },
                    },
                  },
                  [
                    _c("w-fa", { attrs: { icon: "download" } }),
                    _c("w-spacer"),
                    _vm._v(_vm._s(_vm.$ct("download")) + " "),
                  ],
                  1
                ),
                _c(
                  "w-button",
                  {
                    staticClass: "download ml",
                    attrs: { disabled: _vm.isPreparingSendModal },
                    on: {
                      click: function ($event) {
                        return _vm.send()
                      },
                    },
                  },
                  [
                    _c("w-fa", { attrs: { icon: "envelope" } }),
                    _c("w-spacer"),
                    _vm._v(" " + _vm._s(_vm.$ct("send")) + " "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.openSendModal,
            callback: function ($$v) {
              _vm.openSendModal = $$v
            },
            expression: "openSendModal",
          },
        },
        [
          _c("app-report-send-modal", {
            attrs: { attachment: _vm.attachment },
            on: {
              cancel: function ($event) {
                _vm.openSendModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100 preview",
          attrs: { "full-height": "", "escape-close": "" },
          model: {
            value: _vm.openPreview,
            callback: function ($$v) {
              _vm.openPreview = $$v
            },
            expression: "openPreview",
          },
        },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("components.sales.preview"))),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.openPreview = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c("app-pdf-viewer", {
                attrs: { images: _vm.images, blob: _vm.blob },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }